import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { AnalystCard } from "@/components/AnalystCard";

export default function Analysts() {
  const { cat } = useParams();
  const navigate = useNavigate();
  const [analysts, setAnalysts] = useState([]);
  const active = cat ? decodeURIComponent(cat) : "All";

  useEffect(() => {
    client.get("/analysts").then((r) => setAnalysts(r.data)).catch(() => {});
  }, []);

  const categories = useMemo(() => {
    const s = new Set();
    analysts.forEach((a) => (a.types || []).forEach((t) => s.add(t)));
    return ["All", ...Array.from(s)];
  }, [analysts]);

  const filtered = active === "All" ? analysts : analysts.filter((a) => (a.types || []).includes(active));

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-12">
      <p className="font-mono-cl text-[11px] tracking-[0.28em] text-[#ccff00] uppercase mb-2">The Desk</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">
        {active === "All" ? "Analyst Partners" : <>{active} <span className="text-zinc-500">Analysts</span></>}
      </h1>
      <p className="text-zinc-400 mt-3 max-w-2xl">
        Independent minds. Different markets. Different views. Follow their research, market calls, and track records
      </p>

      {/* category filter */}
      <div className="flex flex-wrap gap-2 mt-6">
        {categories.map((c) => {
          const isActive = c === active;
          return (
            <button key={c} data-testid={`category-pill-${c}`}
              onClick={() => navigate(c === "All" ? "/analysts" : `/analysts/category/${encodeURIComponent(c)}`)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${isActive ? "bg-[#ccff00] text-black" : "border border-white/10 text-zinc-400 hover:text-white hover:border-white/25"}`}>
              {c}
            </button>
          );
        })}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-8">
        {filtered.map((a) => <AnalystCard key={a.slug} a={a} />)}
        {filtered.length === 0 && (
          <p className="col-span-full text-zinc-500 py-16 text-center">
            No analysts in this category yet. <Link to="/analysts" className="text-[#ccff00]">View all</Link>
          </p>
        )}
      </div>
    </div>
  );
}
